import { render, staticRenderFns } from "./p08.vue?vue&type=template&id=7c93f8a4&scoped=true&"
import script from "./p08.vue?vue&type=script&lang=js&"
export * from "./p08.vue?vue&type=script&lang=js&"
import style0 from "./p08.vue?vue&type=style&index=0&id=7c93f8a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c93f8a4",
  null
  
)

export default component.exports